package ru.villawonka.app.presentation.screens.favorites.viewmodel

import ru.villawonka.app.common.mvvm.UIState
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.presentation.model.PostUIModel

sealed class FavoritesUIState : UIState {

    data object Loading : FavoritesUIState()

    data object Empty : FavoritesUIState()

    data class Error(val failure: NetworkFailure) : FavoritesUIState()

    data class Data(val posts: List<PostUIModel>) : FavoritesUIState()
}

fun FavoritesUIState.asData(): FavoritesUIState.Data? = this as? FavoritesUIState.Data